import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getPatient } from "@/app/api/patient";
import { getPortalUser } from "./portal-user";

export const appQueriesStore = createQueryKeys("app", {
  user: {
    queryKey: null,
    queryFn: getPortalUser,
  },

  patient: {
    queryKey: null,
    queryFn: getPatient,
  },
});
